module.exports = __webpack_public_path__ + "img/feature_buy_en.ab77d9c7.png";